import { z } from 'zod';
/**
 * Subscription — a tenant's SaaS plan state.
 *
 * 3 plans (prices with Minari discount -25%):
 *   - Starter : 49 €/mo, 1 number, 500 min, 5 €/day cap
 *   - Pro     : 195 €/mo, 3 numbers, unlimited fair-use, 15 €/day cap
 *   - Enterprise : custom
 *
 * Source of truth: Stripe (via webhook). Our DB mirrors it.
 *
 * numberQuotaOverride is a super-admin override of the plan default;
 * effectiveNumberQuota = override ?? maxNumbers (see Subscription
 * aggregate, backend).
 */
export const PlanIdSchema = z.enum(['starter', 'pro', 'enterprise']);
export const SubscriptionStatusSchema = z.enum([
    'trial',
    'active',
    'past_due',
    'suspended',
    'cancelled',
]);
export const SuspensionReasonSchema = z.enum(['daily_cap', 'payment_failed', 'manual', '']);
export const SubscriptionSchema = z.object({
    id: z.string(),
    tenantEmail: z.string().email(),
    planId: PlanIdSchema,
    status: SubscriptionStatusSchema,
    trialEndsAt: z.coerce.date().nullable(),
    currentPeriodStart: z.coerce.date(),
    currentPeriodEnd: z.coerce.date(),
    dailyCostCapEur: z.number().nonnegative(),
    maxNumbers: z.number().int().nonnegative(),
    numberQuotaOverride: z.number().int().nonnegative().nullable().default(null),
    monthlyPriceEur: z.number().nonnegative(),
    stripeCustomerId: z.string().default(''),
    stripeSubscriptionId: z.string().default(''),
    suspendedAt: z.coerce.date().nullable().default(null),
    suspendedReason: SuspensionReasonSchema.default(''),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
export const UsageCounterSchema = z.object({
    id: z.string(),
    tenantEmail: z.string().email(),
    date: z.string(), // YYYY-MM-DD UTC
    callsCount: z.number().int().nonnegative(),
    callsMinutes: z.number().nonnegative(),
    callsCostEur: z.number().nonnegative(),
    smsCount: z.number().int().nonnegative(),
    smsCostEur: z.number().nonnegative(),
    alertedAt70Pct: z.boolean().default(false),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
//# sourceMappingURL=subscription.schema.js.map